import {createFileRoute} from '@tanstack/react-router'

import CreativesScreen from '@protected/creatives'

export const Route = createFileRoute('/_protected/creatives')({component: CreativesScreen})
